import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { i18n } from 'i18n';
import { Link as RouterLink } from 'react-router-dom';

interface BackNavButtonProps {
  path: string;
  text: string | null;
  isLarge: boolean;
}

const BackNavButton = ({ path, text, isLarge }: BackNavButtonProps) => (
  (isLarge && text) ? (
    <Button
      aria-label="back navigation"
      color="inherit"
      component={RouterLink}
      to={path}
      startIcon={<ArrowBackIcon />}
    >
      {i18n._('BACK TO').concat(` ${text}`)}
    </Button>
  ) : (
    <IconButton
      color="inherit"
      aria-label="back navigation"
      component={RouterLink}
      to={path}
      size="large"
    >
      <ArrowBackIcon />
    </IconButton>
  )
);

export default BackNavButton;
